// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Contact_contact__XUvE9 {  
    display: flex;
    flex-direction: column;
    margin-top: 90px;
    margin-bottom: 3rem;
    width: 100%;
}
.Contact_contact__XUvE9 h2{
    font-size: 2.5rem;
    font-weight: 700;
    margin: 24px auto;
    width: 80%;
    text-align: center;
}
.Contact_contactMethods__PtmuI {   
    margin: 0 auto;
    margin-top: 2rem;
    width: 100%;
}
.Contact_contactMethod__eVkV5 {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    flex-wrap: wrap;
    font-size: 24px;
    margin-bottom: 25px;
}
.Contact_contactType__VBHtF {
    width: 30%;  
    font-weight: bold;
    text-align: right;
    margin-right: 1em;
}
.Contact_contactInfo__niJ7l {
    width: 50%;  
}
.Contact_social-icon__5SuRa{
    width: 10%;
}
.Contact_divider__OX375 {
    width: 90%;
    margin: 0 5%;
}

@media screen and (max-width: 768px) {
    .Contact_contactType__VBHtF {
        width: 35%;
    }
    .Contact_contactInfo__niJ7l {
        width: 55%;
    }
}
@media screen and (max-width: 508px) {
    .Contact_contactMethod__eVkV5 {
        font-size: 18px;
    }
    .Contact_contactType__VBHtF {
        width: 35%;
    }
    .Contact_contactInfo__niJ7l {
        width: 55%;
    }
}
@media screen and (max-width: 308px) {
    .Contact_contactType__VBHtF {
        width: 30%;
    }
    .Contact_contactInfo__niJ7l {
        width: 60%;
    }
    .Contact_contactMethod__eVkV5 {
        font-size: 16px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ContactUs/Contact.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;AACA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".contact {  \n    display: flex;\n    flex-direction: column;\n    margin-top: 90px;\n    margin-bottom: 3rem;\n    width: 100%;\n}\n.contact h2{\n    font-size: 2.5rem;\n    font-weight: 700;\n    margin: 24px auto;\n    width: 80%;\n    text-align: center;\n}\n.contactMethods {   \n    margin: 0 auto;\n    margin-top: 2rem;\n    width: 100%;\n}\n.contactMethod {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    font-size: 24px;\n    margin-bottom: 25px;\n}\n.contactType {\n    width: 30%;  \n    font-weight: bold;\n    text-align: right;\n    margin-right: 1em;\n}\n.contactInfo {\n    width: 50%;  \n}\n.social-icon{\n    width: 10%;\n}\n.divider {\n    width: 90%;\n    margin: 0 5%;\n}\n\n@media screen and (max-width: 768px) {\n    .contactType {\n        width: 35%;\n    }\n    .contactInfo {\n        width: 55%;\n    }\n}\n@media screen and (max-width: 508px) {\n    .contactMethod {\n        font-size: 18px;\n    }\n    .contactType {\n        width: 35%;\n    }\n    .contactInfo {\n        width: 55%;\n    }\n}\n@media screen and (max-width: 308px) {\n    .contactType {\n        width: 30%;\n    }\n    .contactInfo {\n        width: 60%;\n    }\n    .contactMethod {\n        font-size: 16px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contact": `Contact_contact__XUvE9`,
	"contactMethods": `Contact_contactMethods__PtmuI`,
	"contactMethod": `Contact_contactMethod__eVkV5`,
	"contactType": `Contact_contactType__VBHtF`,
	"contactInfo": `Contact_contactInfo__niJ7l`,
	"social-icon": `Contact_social-icon__5SuRa`,
	"divider": `Contact_divider__OX375`
};
export default ___CSS_LOADER_EXPORT___;
